import styled, { css } from "styled-components";
import { type SpaceProps, space } from "styled-system";
import { getBreakpoint } from "../../themes/common";

const INPUT_WIDTH = 20;
const INPUT_HEIGHT = 20;

const Input = styled.div``;

const radioLeftStyles = css`
    padding-left: 42px;
    &::before {
        left: 0;
    }
    &::after {
        left: 7px;
    }

    html[dir="rtl"] & {
        padding-left: 0;
        padding-right: 42px;
        &::before {
            left: auto;
            right: 0;
        }
        &::after {
            left: auto;
            right: 7px;
        }
    }
`;

const radioRightStyles = css`
    padding-right: 42px;
    &::before {
        right: 0;
    }
    &::after {
        right: 7px;
    }

    html[dir="rtl"] & {
        padding-left: 42px;
        padding-right: 0;
        &::before {
            left: 0;
            right: auto;
        }
        &::after {
            left: 7px;
            right: auto;
        }
    }
`;

export const Radio = styled(Input)<{ checked?: boolean; disabled?: boolean; radioRight?: boolean }>`
    position: relative;
    margin: 10px 0;
    transition: opacity 0.3s;
    cursor: pointer;
    opacity: ${({ disabled }) => (disabled ? 0.65 : 1)};

    &::before {
        position: absolute;
        top: 3px;
        width: 20px;
        height: 20px;
        content: "";
        border: 2px solid ${({ theme }) => theme.color.dark};
        border-radius: 50%;
    }

    &::after {
        display: ${({ checked }) => (checked ? "block" : "none")};
        position: absolute;
        top: 10px;
        width: 6px;
        height: 6px;
        content: "";
        background-color: ${({ theme }) => theme.color.primary};
        border-radius: 50%;
    }

    ${({ radioRight }) =>
        radioRight
            ? css`
                  @media ${getBreakpoint("down", "sm")} {
                      ${radioLeftStyles};
                  }
                  @media ${getBreakpoint("up", "sm")} {
                      ${radioRightStyles};
                  }
              `
            : radioLeftStyles};
`;

export const Label = styled.label`
    font-weight: 400;
    cursor: pointer;
`;

export const Checkbox = styled.label`
    display: inline;
    position: relative;
    margin: 0;
    padding: 0;
    padding-left: 36px;
    font-family: ${({ theme }) => theme.fontFamily.regular};
    font-size: 1.6rem;
    -moz-osx-font-smoothing: grayscale;
    font-weight: 300;
    line-height: 2.4rem;
    border-radius: 4px;
    cursor: pointer;

    /* checkbox square */
    &::before {
        position: absolute;
        top: 2px;
        left: 0;
        width: ${INPUT_WIDTH}px;
        height: ${INPUT_HEIGHT}px;
        content: "";
        background-color: ${({ theme }) => theme.color.lightest};
        border: 2px solid #e4e4e4;
        border-radius: 4px;
        box-sizing: border-box;
    }

    html[dir="rtl"] & {
        padding-left: 0;
        padding-right: 36px;
        &::before {
            left: auto;
            right: 0;
        }
    }
`;

export const Wrapper = styled.div<SpaceProps>`
    ${space};

    input {
        display: none;
    }

    input:checked ~ ${Checkbox} {
        &::before {
            position: absolute;
            top: 2px;
            left: 0;
            width: ${INPUT_WIDTH}px;
            height: ${INPUT_HEIGHT}px;
            content: "";
            background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDEwIDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDMuNzMzMzNMMy42IDYuMzMzMzNMOSAxIiBzdHJva2U9IiNFNTAwMDAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=");
            background-repeat: no-repeat;
            background-position: center;
        }
    }

    html[dir="rtl"] & {
        input:checked ~ ${Checkbox} {
            &::before {
                left: auto;
                right: 0;
            }
        }
    }
`;

export default Input;
